import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProcesiService {

  constructor(private _http: HttpClient) { }

  dohvatiSveProizvode(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dohvati_sve_artikle', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSveProcese(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dohvati_sve_procese', a)
      .pipe(map((res: any) => res));
  }

  urediProces(a: any) {
    return this._http.put(AppConfig.ipAddress + 'uredivanje_procesa', a)
      .pipe(map((res: any) => res));
  }

  kreirajProces(a: any) {
    return this._http.post(AppConfig.ipAddress + 'kreiraj_procese', a)
      .pipe(map((res: any) => res));
  }
  
}
